// extracted by mini-css-extract-plugin
export var header = "_x0-1";
export var maskBottom = "_x0-6";
export var maskMiddle = "_x0-7";
export var maskTop = "_x0-5";
export var root = "_x0-0";
export var scrollDownButton = "_x0-3";
export var scrollDownButtonHidden = "_x0-4";
export var viewport = "_x0-2";